import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '../components/Alert';
import { mountAngular, unmountAngular } from 'app/angular-app.bootstrap';
import { reportError } from '../observability';

export function AngularHost() {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [mountFailed, setMountFailed] = useState(false);

  useEffect(() => {
    if (ref.current) {
      // A rejeição não é um throw de render, então um ErrorBoundary não a captura;
      // por isso o estado de erro é tratado aqui, no ponto que chama o bootstrap.
      mountAngular(ref.current).catch((error: unknown) => {
        reportError(error, { origin: 'angular_mount' });
        setMountFailed(true);
      });
    }
    return () => {
      void unmountAngular();
    };
  }, []);

  return (
    <div ref={ref} className="angular-host">
      {mountFailed && <Alert severity="error">{t('host.mountError')}</Alert>}
    </div>
  );
}
